import { useNicheChartSelectorModel } from './niche-chart-selector.model'
import type { INicheChartSelectorBaseProps } from './niche-chart-selector.types'
import { NicheChartSelectorView } from './niche-chart-selector.view'

export const NicheChartSelector = (props: INicheChartSelectorBaseProps) => {
  const nicheChartSelectorModel = useNicheChartSelectorModel(props)
  return <NicheChartSelectorView {...props} {...nicheChartSelectorModel} />
}
